import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';

const PendingDuplications = () => {
  const dispatch = useDispatch();
  const { pendingDuplications } = useSelector((state) => state.general);
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'pendingDuplications',
        route: 'pendingDuplications/getPendingDuplications',
        fields: ['name', 'status', 'originalAccountId', 'originalCampaignId', 'ruleId', 'newCampaignId', 'createdAt'],
      })
    );
  }, [dispatch]);

  const columns = [
    {
      field: '_id',
      headerName: 'Pending ID',
      width: 250,
      renderCell: (params) => <Link to={`/pendingDuplication/${params.value}`}>{params.value}</Link>,
    },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'originalAccountId', headerName: 'Original Account ID', width: 200 },
    { field: 'originalCampaignId', headerName: 'Original Campaign ID', width: 200 },
    {
      field: 'ruleId',
      headerName: 'Rule ID',
      width: 200,
      renderCell: (params) => <Link to={`/rule/${params.value}`}>{params.value}</Link>,
    },
    { field: 'newCampaignId', headerName: 'New Campaign ID', width: 200 },
    { field: 'createdAt', headerName: 'Created At', width: 200 },
  ];

  console.log({ pendingDuplications });
  return Array.isArray(pendingDuplications) ? (
    <>
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center'>
          <div
            className='col-lg-12 d-flex justify-content-center border-bottom'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <h1>Pending Duplications</h1>
          </div>
        </div>
      </div>
      <div className='row d-flex justify-content-center m-4'>
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={pendingDuplications.map((item, index) => ({ id: index, ...item }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </div>
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default PendingDuplications;
